import { polyfill, trustPolicies } from '../assets/Sanitizer.js';
export const polyfilled = polyfill();
export { trustPolicies };
